import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.reducer';

export const selectAuthState = createFeatureSelector<AuthState>('authState');

export const selectUser = createSelector(selectAuthState, (state: AuthState) => state && state.user ? state.user : null);
